import { useEffect } from "react";

import { useAuthStore } from "@/features/auth/store";
import { applyUiTemplate, usesTemplateE } from "@/lib/ui-template";

/** True when presentation E is active for the signed-in user's clinic. */
export function useIsUiTemplateE(): boolean {
  return useAuthStore((s) => usesTemplateE(s.me));
}

/**
 * Keeps `data-ui="e"` on <html> in step with the module (ADR 0068). Removed
 * when the module goes off, on clinic switch, and when the shell unmounts
 * (sign-out): public pages never carry the theme.
 */
export function useUiTemplateAttribute(): boolean {
  const enabled = useIsUiTemplateE();
  useEffect(() => {
    applyUiTemplate(enabled);
    return () => applyUiTemplate(false);
  }, [enabled]);
  return enabled;
}
